import { __assign, __rest } from "tslib";
import React from 'react';
import PremiumIcon from '@wix/da-ds/pkg/Icons/24x24/Premium';
import FollowingWatchIcon from '@wix/da-ds/pkg/Icons/16x16/FollowingWatch';
var PremiumFolderDataIcon = function (_a) {
    var premiumFolderData = _a.premiumFolderData, iconProps = __rest(_a, ["premiumFolderData"]);
    switch (premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.type) {
        case 'paid':
            return React.createElement(PremiumIcon, __assign({}, iconProps));
        case 'watchers':
            return React.createElement(FollowingWatchIcon, __assign({}, iconProps));
        default:
            return null;
    }
};
PremiumFolderDataIcon.displayName = 'PremiumFolderDataIcon';
export default PremiumFolderDataIcon;
//# sourceMappingURL=PremiumFolderDataIcon.js.map